export default __webpack_public_path__ + "static/media/banner-img-1.e462eaa9.png";